import script from "./VerificationModalGetStarted.vue?vue&type=script&setup=true&lang=js"
export * from "./VerificationModalGetStarted.vue?vue&type=script&setup=true&lang=js"

import "./VerificationModalGetStarted.vue?vue&type=style&index=0&id=27e5af5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-27e5af5a"]])

export default __exports__